import { generatePdf } from "../../utilities/PDFMakeUtil";
import pdfImage from "../../components/PDF/pdfImage";

export const pdfRPT210 = (dataReport, setLoading, setDialogPDF) => {
    setLoading(true);

    const chk = (key) => {
        if (dataReport.length > 0) {
            return dataReport[0][key] === "Y" ? pdfImage.checkBox : pdfImage.unchecked;
        }
    };

    const setViewPDF = (key) => {
        if (dataReport.length > 0) {
            return dataReport[0][key] === null || dataReport[0][key] === "" ? "" : dataReport[0][key];
        }
    };

    const setTable = () => {
        let arr = [];
        for (const iterator of dataReport) {
            arr.push([
                { alignment: "center", text: iterator.routeNo },
                { alignment: "center", text: iterator.areaOwner },
                { text: iterator.areaLocation },
                { alignment: "center", text: iterator.areaSurface },
                { alignment: "center", text: iterator.planNo },
                { alignment: "center", text: iterator.asDesignPipeLength },
                { alignment: "center", text: iterator.resultLength },
                { alignment: "center", text: iterator.resultAccure },
                { alignment: "center", text: iterator.approveDate },
                { alignment: "center", text: iterator.duration },
                { alignment: "center", text: iterator.datePlanBegin },
                { alignment: "center", text: iterator.datePlanEnd },
                { alignment: "center", text: iterator.dateActualBegin },
                { alignment: "center", text: iterator.dateActualEnd },
                { alignment: "center", text: iterator.acceptDate },
            ]);
        }
        return arr;
    };

    // Date
    const container_1 = {
        layout: "noBorders",
        table: {
            widths: ["*"],
            style: "fontStyle",
            body: [[{ style: "fontStyle_right", text: "วันที่ " + dataReport[0].reportDate }]],
        },
    };

    const container_2 = {
        layout: "noBorders",
        table: {
            widths: ["*", "*", "*", "*"],
            body: [
                [
                    {
                        layout: "noBorders",
                        table: {
                            widths: ["20%", "10%", "30%", "10%", "30%"],
                            body: [
                                [{ text: "" }, { image: chk("weekFlag"), width: 15, height: 15 }, { text: "รายสัปดาห์" }, { image: pdfImage.unchecked, width: 15, height: 15 }, { text: "รายเดือน" }],
                                [{ colSpan: 2, text: "เลขที่สัญญา" }, {}, { colSpan: 3, text: setViewPDF("contractNo") }, { image: chk("monthFlag"), width: 15, height: 15 }, { text: "รายเดือน" }],
                                [{ colSpan: 2, text: "PO" }, {}, { colSpan: 3, text: setViewPDF("planNo") }, {}, {}],
                                [{ colSpan: 2, text: "AUC(ค่าแรง)" }, {}, { colSpan: 3, text: setViewPDF("auc") }, {}, {}],
                                [{ colSpan: 2, text: "วันที่ลงนาม" }, {}, { colSpan: 3, text: setViewPDF("contractSignDate") }, {}, {}],
                            ],
                        },
                    },
                    {
                        layout: "noBorders",
                        table: {
                            widths: ["30%", "70%"],
                            body: [
                                [{ text: "ระหว่างวันที่" }, { text: setViewPDF("reportDateBegin") + " ถึงวันที่ " + setViewPDF("reportDateEnd") }],
                                [{ text: "ผู้ควบคุมงาน" }, { text: setViewPDF("supervisorName") }],
                                [{ text: "ผู้รับจ้าง" }, { text: setViewPDF("contractorName") }],
                                [{ text: "วงเงินสัญญา" }, { text: setViewPDF("contractAmount") }],
                                [{ text: "อัตราค่าปรับ" }, { text: setViewPDF("fineRate") }],
                            ],
                        },
                    },
                    {
                        layout: "noBorders",
                        table: {
                            widths: ["40%", "60%"],
                            body: [
                                [{ margin: [0, 15, 0, 0], text: "" }, {}],
                                [{ text: "วันเริ่มสัญญา" }, { text: setViewPDF("contractDateBegin") }],
                                [{ text: "วันสิ้นสุดสัญญา" }, { text: setViewPDF("contractDateEnd") }],
                                [{ text: "วันส่งงานเส้นทาง" }, { text: setViewPDF("lastDeliverDate") }],
                                [{ text: "ระยะเวลาตามสัญญา" }, { text: setViewPDF("contractPeriod") }],
                            ],
                        },
                    },
                    {
                        layout: "noBorders",
                        table: {
                            widths: ["45%", "55%"],
                            body: [
                                [{ margin: [0, 15, 0, 0], text: "" }, {}],
                                [{ text: "วงเงินดำเนินการ" }, { text: setViewPDF("operateAmount") }],
                                [{ text: "วงเงินคงเหลือ" }, { text: setViewPDF("remainAmount") }],
                                [{ margin: [0, 15, 0, 0], text: "" }, {}],
                                [{ text: "ระยะเวลาก่อสร้างจริง" }, { text: setViewPDF("actualPeriod") }],
                            ],
                        },
                    },
                ],
            ],
        },
    };

    // table
    const container_3 = {
        margin: [0, 20, 0, 0],
        table: {
            headerRows: 3,
            dontBreakRows: true,
            style: "fontStyle",
            widths: ["5%", "16%", "16%", "6%", "8%", "8%", "4%", "4%", "5%", "5%", "4%", "4%", "4%", "5%", "6%"],
            body: [
                [
                    { alignment: "center", rowSpan: 3, text: "เส้นทาง" },
                    { alignment: "center", rowSpan: 3, text: "หน่วยงานเจ้าของพื้นที่" },
                    { alignment: "center", rowSpan: 3, text: "สถานที่" },
                    { alignment: "center", rowSpan: 3, text: "ผิวจราจร" },
                    { alignment: "center", rowSpan: 3, text: "เลขที่แบบแปลน" },
                    { alignment: "center", text: "ตามแบบ" },
                    { alignment: "center", colSpan: 2, text: "ผลงานก่อสร้าง" },
                    {},
                    { alignment: "center", rowSpan: 3, text: "วันที่\nอนุมัติ\nเข้า" },
                    { alignment: "center", rowSpan: 3, text: "ระยะ\nเวลา\n(วัน)" },
                    { alignment: "center", colSpan: 4, text: "วันที่ทำการก่อสร้าง" },
                    {},
                    {},
                    {},
                    { alignment: "center", rowSpan: 3, text: "ตรวจรับงาน\nครั้งสุดท้าย\nวันที่" },
                ],
                [{}, {}, {}, {}, {}, { alignment: "center", rowSpan: 2, text: "ความยาวท่อ(ม.)" }, { alignment: "center", colSpan: 2, text: "ความยาวท่อ(ม.)" }, {}, {}, {}, { alignment: "center", colSpan: 2, text: "ตามแผน" }, {}, { alignment: "center", colSpan: 2, text: "ตามจริง" }, {}, {}],
                [
                    {},
                    {},
                    {},
                    {},
                    {},
                    {},
                    { alignment: "center", text: "สัปดาห์" },
                    { alignment: "center", text: "รวม" },
                    {},
                    {},
                    { alignment: "center", text: "เริ่มงาน" },
                    { alignment: "center", text: "สิ้นสุด" },
                    { alignment: "center", text: "เริ่มงาน" },
                    { alignment: "center", text: "แล้วเสร็จ" },
                    {},
                ],
                ...setTable(),
            ],
        },
    };
    // footer
    const container_4 = {
        table: {
            style: "fontStyle",
            widths: ["5.7%", "15%", "16%", "6%", "8%", "8%", "4%", "4%", "5.1%", "5%", "4%", "4.1%", "4%", "5%", "6%"],
            body: [
                [
                    { border: [1, 0, 1, 1], alignment: "center", colSpan: 5, text: "ผลรวม" },
                    { border: [1, 0, 1, 1], text: "" },
                    { border: [1, 0, 1, 1], text: "" },
                    { border: [1, 0, 1, 1], text: "" },
                    { border: [1, 0, 1, 1], text: "" },
                    { border: [1, 0, 1, 1], text: "" },
                    { border: [1, 0, 1, 1], text: "" },
                    { border: [1, 0, 1, 1], text: "" },
                    { colSpan: 7, border: [1, 0, 1, 1], text: "" },
                    {},
                    {},
                    {},
                    {},
                    {},
                    {},
                ],
            ],
        },
        layout: {
            fillColor: function (rowIndex, node, columnIndex) {
                return rowIndex < 1 && columnIndex > 7 ? "#CCCCCC" : null;
            },
            hLineWidth: function (i, node) {
                return 0.25;
            },
            vLineWidth: function (i, node) {
                return 0.25;
            },
        },
    };

    const container_5 = {
        layout: "noBorders",
        margin: [0, 10, 0, 0],
        table: {
            widths: ["50%", "30%", "20%"],
            style: "fontStyle",
            body: [
                [
                    {
                        layout: "noBorders",
                        table: {
                            widths: ["20%", "80%"],
                            style: "fontStyle",
                            body: [
                                [{ text: "หมายเหตุ" }, { text: "1. ตรวจรับงานแล้ว ..................... เส้นทาง ระหว่างดำเนินการ .......................... เส้นทาง" }],
                                [{}, { text: "2. เบิกเงินแล้ว ............................ งวด เป็นเงิน .......................... บาท" }],
                                [
                                    {},
                                    {
                                        layout: "noBorders",
                                        margin: [0, 0, 0, 0],
                                        table: {
                                            widths: ["40%", "5%", "45%"],
                                            style: "fontStyle",
                                            body: [
                                                [{ text: "3. งานล่าช้า .........................." }, { image: pdfImage.unchecked, width: 15, height: 15 }, { text: "ปัญหากรรมสิทธิ์พื้นที่ก่อสร้าง" }],
                                                [{}, { image: pdfImage.unchecked, width: 15, height: 15 }, { text: "อื่น ...................." }],
                                            ],
                                        },
                                    },
                                ],
                                [{}, { text: "4. ขยายอายุสัญญา ...................... ครั้ง " }],
                                [{}, { text: "5. เพิ่มวงเงินสัญญาอีก ................................................ บาท" }],
                                [{}, { text: "6. .............................................................." }],
                            ],
                        },
                    },
                    {
                        layout: "noBorders",
                        table: {
                            widths: ["*"],
                            style: "fontStyle",
                            body: [[{ alignment: "center", text: "คณะกรรมการตรวจการจ้าง" }]],
                        },
                    },
                    {
                        layout: "noBorders",
                        table: {
                            widths: ["*"],
                            style: "fontStyle",
                            body: [[{ text: "ประธานการรมการ" }], [{ text: "กรรมการ" }], [{ text: "กรรมการและเลขานุการ" }]],
                        },
                    },
                ],
            ],
        },
    };

    const container_6 = {
        layout: "noBorders",
        margin: [0, 20, 0, 0],
        table: {
            widths: ["10%", "30%"],
            body: [
                [{ colSpan: 2, text: "เรียน กรรมการและเลขานุการ เลขที่สัญญา  " + setViewPDF("contractNo") }, {}],
                [{ alignment: "center", text: "เพื่อโปรดทราบ" }, {}],
                [{}, { alignment: "center", text: "( ........................................................ )" }],
                [{}, { alignment: "center", text: "ผู้ควบคุมงาน" }],
                [{}, { alignment: "center", text: "ผู้จัดทำรายงาน" }],
            ],
        },
    };

    let sheet = {
        content: [container_1, container_2, container_3, container_4, container_5, container_6],
        styles: {
            header: {
                alignment: "left",
                fontSize: 15,
                bold: true,
                margin: [0, 0, 0, 10],
            },
            fontStyle: {
                fontSize: 15,
            },
            fontStyle_center: {
                alignment: "center",
                fontSize: 15,
            },
            fontStyle_left: {
                alignment: "left",
                fontSize: 15,
            },
            fontStyle_right: {
                alignment: "right",
                fontSize: 15,
            },
            tableExample: {
                alignment: "right",
                margin: [0, 5, 0, 15],
            },
            tableHeader: {
                bold: true,
                fontSize: 15,
                color: "black",
                alignment: "center",
            },
            signature: {
                fontSize: 15,
                decoration: "underline",
                decorationStyle: "dotted",
                decorationColor: "black",
            },
            signature_dashed: {
                fontSize: 15,
                decoration: "underline",
                decorationStyle: "dashed",
                decorationColor: "black",
            },
            signature_wavy: {
                fontSize: 15,
                decoration: "underline",
                decorationStyle: "wavyF",
                decorationColor: "black",
            },
        },
        // pageOrientation: "portrait",
        pageOrientation: "landscape",
        pageSize: "A4",
        pageMargins: [30, 20, 30, 30],
        defaultStyle: {
            font: "THSarabunNew",
            alignment: "justify",
        },
    };

    // var content = {
    //     pageOrientation: "landscape",
    //     pageSize: "A4",
    //     content: [header(), data2],
    //     pageMargins: [15, 20, 40, 40],
    //     defaultStyle: {
    //         font: "THSarabunNew",
    //         alignment: "justify",
    //     },
    // };

    generatePdf(true, sheet, (dataUrl) => {
        setDialogPDF({ open: false, pdfURL: dataUrl });
        setLoading(false);
    });
};
